import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.search.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* jshint esversion: 8 */
import { ConfigurationService } from '../Shared/Configuration';
import { LocalStorageManager } from '../Shared/LocalStorageManager';
import { SessionStorageManager } from '../Shared/SessionStorageManager';
import { URLSearchParameters } from '../Shared/URLSearchParameters';
var _tokenKeyName = "AuthToken";
var _idTokenKeyName = "IdToken";
var _expiresAfterName = "ExpiresAfter";
var _csrfToken = "CSRFToken";
window.mppw_refreshTokenPromise = null;
export var OAuthService = /*#__PURE__*/function () {
  function OAuthService() {
    _classCallCheck(this, OAuthService);
  }

  _createClass(OAuthService, null, [{
    key: "Token",
    get: function get() {
      var tokenValue = LocalStorageManager.getItem(_tokenKeyName);
      var token = tokenValue === "null" ? null : tokenValue;
      return token;
    },
    set: function set(token) {
      LocalStorageManager.setItem(_tokenKeyName, token);
    }
  }, {
    key: "IdToken",
    get: function get() {
      var idTokenValue = LocalStorageManager.getItem(_idTokenKeyName);
      var idToken = idTokenValue === "null" ? null : idTokenValue;
      return idToken;
    },
    set: function set(idToken) {
      LocalStorageManager.setItem(_idTokenKeyName, idToken);
    }
  }, {
    key: "ExpiresAfter",
    get: function get() {
      var expiresAfterValue = LocalStorageManager.getItem(_expiresAfterName);
      var expiresAfter = expiresAfterValue === "null" ? null : new Date(expiresAfterValue);
      return expiresAfter;
    },
    set: function set(expiresAfter) {
      LocalStorageManager.setItem(_expiresAfterName, expiresAfter);
    }
  }, {
    key: "CSRFToken",
    get: function get() {
      try {
        var token = JSON.parse(SessionStorageManager.getItem(_csrfToken));
        return token;
      } catch (_unused) {
        return null;
      }
    },
    set: function set(token) {
      SessionStorageManager.setItem(_csrfToken, JSON.stringify(token));
    }
  }, {
    key: "SignIn",
    value: function SignIn() {
      ConfigurationService.GetAuthConfiguration().then(function (oauthConfig) {
        if (!!oauthConfig) {
          var url = "".concat(oauthConfig.signInUrl, "?") + "response_type=".concat(oauthConfig.responseType) + "&scope=".concat(oauthConfig.scope) + "&client_id=".concat(oauthConfig.clientId) + "&redirect_uri=".concat(oauthConfig.redirectUrl) + "&nonce=".concat(oauthConfig.nonce) + "&state=".concat(encodeURIComponent(window.location));
          OAuthService.Token = null;
          window.location.replace(url);
        }
      });
    }
  }, {
    key: "SignOut",
    value: function SignOut() {
      ConfigurationService.GetAuthConfiguration(true).then(function (oauthConfig) {
        if (!!oauthConfig) {
          var url = "".concat(oauthConfig.signOutUrl, "?") + "id_token_hint=".concat(OAuthService.IdToken) + "&post_logout_redirect_uri=".concat(oauthConfig.postLogoutRedirectUrl) + "&state=".concat(encodeURI(window.location));
          OAuthService.Token = null;
          OAuthService.IdToken = null;
          window.location.replace(url);
        }
      });
    }
  }, {
    key: "SaveCSRFTokenAsync",
    value: function () {
      var _SaveCSRFTokenAsync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return ConfigurationService.GetCSRFToken();

              case 2:
                result = _context.sent;
                OAuthService.CSRFToken = result;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function SaveCSRFTokenAsync() {
        return _SaveCSRFTokenAsync.apply(this, arguments);
      }

      return SaveCSRFTokenAsync;
    }()
  }, {
    key: "SaveAuthTokensAsync",
    value: function () {
      var _SaveAuthTokensAsync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var tokenParamName, userSearchParameters, token, url, tokens;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tokenParamName = "cacheKey";
                userSearchParameters = new URLSearchParameters(window.location.search);
                token = userSearchParameters.get(tokenParamName);

                if (!token) {
                  _context2.next = 9;
                  break;
                }

                if (!!window.history && !!window.history.replaceState && !!token) {
                  url = String(window.location);
                  url = url.replace("?" + tokenParamName + "=", "").replace("&" + tokenParamName + "=", "").replace(token, "");
                  window.history.replaceState({}, document.title, url);
                }

                _context2.next = 7;
                return ConfigurationService.GetAuthToken(token);

              case 7:
                tokens = _context2.sent;

                OAuthService._SaveTokens(tokens);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function SaveAuthTokensAsync() {
        return _SaveAuthTokensAsync.apply(this, arguments);
      }

      return SaveAuthTokensAsync;
    }()
  }, {
    key: "RefreshTokensAsync",
    value: function () {
      var _RefreshTokensAsync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(window.mppw_refreshTokenPromise != null)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", window.mppw_refreshTokenPromise);

              case 2:
                // Put RE-AUTH promise into a global var so that other requests may reuse existing promise until it is resolved
                window.mppw_refreshTokenPromise = new Promise(function (resolve) {
                  if (!OAuthService.Token || !OAuthService.IdToken || !OAuthService.ExpiresAfter) {
                    resolve();
                    return;
                  }

                  ConfigurationService.GetAuthConfiguration(true).then(function (oauthConfig) {
                    if (!!oauthConfig) {
                      var url = "".concat(oauthConfig.signInUrl, "?") + "response_type=".concat(oauthConfig.responseType) + "&scope=".concat(oauthConfig.scope) + "&client_id=".concat(oauthConfig.clientId) + "&redirect_uri=".concat(oauthConfig.redirectUrl) + "&nonce=".concat(oauthConfig.nonce) + "&state=REAUTH";
                      fetch(url, {
                        credentials: "include"
                      }).then(function (response) {
                        return response.json().then(function (tokens) {
                          OAuthService._SaveTokens(tokens);

                          resolve();
                        })["catch"](function () {
                          OAuthService._ClearTokens();

                          resolve();
                        });
                      })["catch"](function () {
                        OAuthService._ClearTokens();

                        resolve();
                      });
                    }
                  });
                })["finally"](function () {
                  // Remove resolved promise from the global var
                  window.mppw_refreshTokenPromise = null;
                });
                return _context3.abrupt("return", window.mppw_refreshTokenPromise);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function RefreshTokensAsync() {
        return _RefreshTokensAsync.apply(this, arguments);
      }

      return RefreshTokensAsync;
    }()
  }, {
    key: "_SaveTokens",
    value: function _SaveTokens(tokens) {
      OAuthService.Token = tokens.accessToken;
      OAuthService.IdToken = tokens.idToken;
      var expiresAfter = new Date();
      expiresAfter.setSeconds(expiresAfter.getSeconds() + tokens.expiresIn - 60);
      OAuthService.ExpiresAfter = expiresAfter;
    }
  }, {
    key: "_ClearTokens",
    value: function _ClearTokens() {
      OAuthService.Token = null;
      OAuthService.IdToken = null;
      OAuthService.ExpiresAfter = null;
    }
  }]);

  return OAuthService;
}();